import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

function AddVatForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    percentage: "",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
  });
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // axios.get(apiKey + "/sanctum/csrf-cookie").then((response) => {
    //   // Extract the CSRF token from cookies
    //   const csrfToken = document.cookie
    //     .split("; ")
    //     .find((row) => row.startsWith("XSRF-TOKEN="))
    //     .split("=")[1];

    // After getting CSRF token, make the logout request
    if (!id) {
      axios
        .post(`${apiKey}/api/rms/admin/vats`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          console.error(err);
          toast.error("Error Occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => setLoading(false));
    } else {
      axios
        .put(`${apiKey}/api/rms/admin/vats/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          console.error(err);
          toast.error("Error Occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => setLoading(false));
    }
    // });
  };

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      // axios.get(apiKey + "/sanctum/csrf-cookie").then((response) => {
      //   // Extract the CSRF token from cookies
      //   const csrfToken = document.cookie
      //     .split("; ")
      //     .find((row) => row.startsWith("XSRF-TOKEN="))
      //     .split("=")[1];

      // After getting CSRF token, make the logout request
      axios
        .get(`${apiKey}/api/rms/admin/vats/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData(res.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setPageLoading(false);
        });
      // });
    }
  }, [id, user?.token]);
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">{languageHelper("Add VAT")}</h1>
          </div>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full lg:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="VAT Name"
                    name="name"
                    onChange={handleChange}
                    value={formData.name}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative">
                  {languageHelper("Percentage")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Percentage"
                    name="percentage"
                    onChange={handleChange}
                    value={formData.percentage}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit") || "Submit"}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back") || "Back"}
              </button>
            </div>
          </form>
        </div>
      </div>
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

export default AddVatForm;
